import { Menu } from '../models/menu';
import { Insight } from '../models/insight';
import { Tag } from '../models/controls';

export const dummy_menus: Menu[] = [
  {
    id: '1',
    name: 'Spaghetti Carbonara',
    description: 'Classic Italian pasta dish with eggs, cheese, pancetta, and pepper.',
    price: 12.99,
    currency: '$',
    available: true,
    isVegetarian: false,
    image_url:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIibPbOeDQQscm9g-fDNdCvROokQJukg8nYQ&s',
    offer: 'Buy one get one free',
    categories: ['Dinner', 'Lunch'],
  },
  {
    id: '2',
    name: 'Margherita Pizza',
    description:
      'Traditional pizza with tomatoes, mozzarella cheese, fresh basil, salt, and extra-virgin olive oil.',
    price: 10.99,
    currency: '$',
    available: true,
    isVegetarian: true,
    image_url:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIibPbOeDQQscm9g-fDNdCvROokQJukg8nYQ&s',
    offer: '20% off',
    categories: ['Dinner', 'Lunch'],
  },
  {
    id: '3',
    name: 'Caesar Salad',
    description:
      'Crisp romaine lettuce and croutons dressed with lemon juice, olive oil, egg, Worcestershire sauce, anchovies, garlic, Dijon mustard, Parmesan cheese, and black pepper.',
    price: 8.99,
    currency: '$',
    available: false,
    image_url:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIibPbOeDQQscm9g-fDNdCvROokQJukg8nYQ&s',
    isVegetarian: true,
    offer: '10% off',
    categories: ['Dinner', 'Lunch'],
  },
  {
    id: '4',
    name: 'Caesar Salad',
    description:
      'Crisp romaine lettuce and croutons dressed with lemon juice, olive oil, egg, Worcestershire sauce, anchovies, garlic, Dijon mustard, Parmesan cheese, and black pepper.',
    price: 8.99,
    currency: '$',
    available: false,
    image_url:
      'https://cookingwithayeh.com/wp-content/uploads/2023/11/Healthy-Caesar-Salad-Without-Anchovies-SQ-5.jpg',
    isVegetarian: true,
    offer: '10% off',
    categories: ['Dinner', 'Lunch'],
  },
  {
    id: '5',
    name: 'Caesar Salad',
    description:
      'Crisp romaine lettuce and croutons dressed with lemon juice, olive oil, egg, Worcestershire sauce, anchovies, garlic, Dijon mustard, Parmesan cheese, and black pepper.',
    price: 8.99,
    currency: '$',
    available: false,
    image_url:
      'https://cookingwithayeh.com/wp-content/uploads/2023/11/Healthy-Caesar-Salad-Without-Anchovies-SQ-5.jpg',
    isVegetarian: true,
    offer: '10% off',
    categories: ['Dinner', 'Lunch'],
  },
  {
    id: '6',
    name: 'Caesar Salad',
    description:
      'Crisp romaine lettuce and croutons dressed with lemon juice, olive oil, egg, Worcestershire sauce, anchovies, garlic, Dijon mustard, Parmesan cheese, and black pepper.',
    price: 8.99,
    currency: '$',
    available: false,
    image_url:
      'https://cookingwithayeh.com/wp-content/uploads/2023/11/Healthy-Caesar-Salad-Without-Anchovies-SQ-5.jpg',
    isVegetarian: true,
    offer: '10% off',
    categories: ['Dinner', 'Lunch'],
  },
  {
    id: '7',
    name: 'Caesar Salad',
    description:
      'Crisp romaine lettuce and croutons dressed with lemon juice, olive oil, egg, Worcestershire sauce, anchovies, garlic, Dijon mustard, Parmesan cheese, and black pepper.',
    price: 8.99,
    currency: '$',
    available: false,
    image_url:
      'https://cookingwithayeh.com/wp-content/uploads/2023/11/Healthy-Caesar-Salad-Without-Anchovies-SQ-5.jpg',
    isVegetarian: true,
    offer: '10% off',
    categories: ['Dinner', 'Lunch'],
  },
  {
    id: '8',
    name: 'Caesar Salad',
    description:
      'Crisp romaine lettuce and croutons dressed with lemon juice, olive oil, egg, Worcestershire sauce, anchovies, garlic, Dijon mustard, Parmesan cheese, and black pepper.',
    price: 8.99,
    currency: '$',
    available: false,
    image_url:
      'https://cookingwithayeh.com/wp-content/uploads/2023/11/Healthy-Caesar-Salad-Without-Anchovies-SQ-5.jpg',
    isVegetarian: true,
    offer: '10% off',
    categories: ['Dinner', 'Lunch'],
  },
  {
    id: '9',
    name: 'Caesar Salad',
    description:
      'Crisp romaine lettuce and croutons dressed with lemon juice, olive oil, egg, Worcestershire sauce, anchovies, garlic, Dijon mustard, Parmesan cheese, and black pepper.',
    price: 8.99,
    currency: '$',
    available: false,
    image_url:
      'https://cookingwithayeh.com/wp-content/uploads/2023/11/Healthy-Caesar-Salad-Without-Anchovies-SQ-5.jpg',
    isVegetarian: true,
    offer: '10% off',
    categories: ['Dinner', 'Lunch'],
  },
  {
    id: '10',
    name: 'Caesar Salad',
    description:
      'Crisp romaine lettuce and croutons dressed with lemon juice, olive oil, egg, Worcestershire sauce, anchovies, garlic, Dijon mustard, Parmesan cheese, and black pepper.',
    price: 8.99,
    currency: '$',
    available: false,
    image_url:
      'https://cookingwithayeh.com/wp-content/uploads/2023/11/Healthy-Caesar-Salad-Without-Anchovies-SQ-5.jpg',
    isVegetarian: true,
    offer: '10% off',
    categories: ['Dinner', 'Lunch'],
  },
  {
    id: '11',
    name: 'Caesar Salad',
    description:
      'Crisp romaine lettuce and croutons dressed with lemon juice, olive oil, egg, Worcestershire sauce, anchovies, garlic, Dijon mustard, Parmesan cheese, and black pepper.',
    price: 8.99,
    currency: '$',
    available: false,
    image_url:
      'https://cookingwithayeh.com/wp-content/uploads/2023/11/Healthy-Caesar-Salad-Without-Anchovies-SQ-5.jpg',
    isVegetarian: true,
    offer: '10% off',
    categories: ['Dinner', 'Lunch'],
  },
  {
    id: '12',
    name: 'Caesar Salad',
    description:
      'Crisp romaine lettuce and croutons dressed with lemon juice, olive oil, egg, Worcestershire sauce, anchovies, garlic, Dijon mustard, Parmesan cheese, and black pepper.',
    price: 8.99,
    currency: '$',
    available: false,
    image_url:
      'https://cookingwithayeh.com/wp-content/uploads/2023/11/Healthy-Caesar-Salad-Without-Anchovies-SQ-5.jpg',
    isVegetarian: true,
    offer: '10% off',
    categories: ['Dinner', 'Lunch'],
  },
  {
    id: '13',
    name: 'Caesar Salad',
    description:
      'Crisp romaine lettuce and croutons dressed with lemon juice, olive oil, egg, Worcestershire sauce, anchovies, garlic, Dijon mustard, Parmesan cheese, and black pepper.',
    price: 8.99,
    currency: '$',
    available: false,
    image_url:
      'https://cookingwithayeh.com/wp-content/uploads/2023/11/Healthy-Caesar-Salad-Without-Anchovies-SQ-5.jpg',
    isVegetarian: true,
    offer: '10% off',
    categories: ['Dinner', 'Lunch'],
  },
  {
    id: '14',
    name: 'Caesar Salad',
    description:
      'Crisp romaine lettuce and croutons dressed with lemon juice, olive oil, egg, Worcestershire sauce, anchovies, garlic, Dijon mustard, Parmesan cheese, and black pepper.',
    price: 8.99,
    currency: '$',
    available: false,
    image_url:
      'https://cookingwithayeh.com/wp-content/uploads/2023/11/Healthy-Caesar-Salad-Without-Anchovies-SQ-5.jpg',
    isVegetarian: true,
    offer: '10% off',
    categories: ['Lunch'],
  },
  {
    id: '15',
    name: 'Caesar Salad',
    description:
      'Crisp romaine lettuce and croutons dressed with lemon juice, olive oil, egg, Worcestershire sauce, anchovies, garlic, Dijon mustard, Parmesan cheese, and black pepper.',
    price: 8.99,
    currency: '$',
    available: false,
    image_url:
      'https://cookingwithayeh.com/wp-content/uploads/2023/11/Healthy-Caesar-Salad-Without-Anchovies-SQ-5.jpg',
    isVegetarian: true,
    offer: '10% off',
    categories: ['Drinks'],
  },
];

export const dummy_stats: Insight[] = [
  {
    id: '1',
    name: 'Most ordered',
    stat: '3 Sales',

    menu: dummy_menus[0],
  },
  {
    id: '2',
    name: 'Highest priced item',
    stat: '5 Sales',
    menu: dummy_menus[1],
  },
  {
    id: '3',
    name: 'Least ordered',
    stat: '1 Sales',
    menu: dummy_menus[2],
  },
];

export const dummy_tags: Tag[] = [
  { name: 'All Food', id: '1', count: 10 },
  { name: 'Breakfast', id: '2', count: 20 },
  { name: 'Lunch', id: '3', count: 30 },
  { name: 'Dinner', id: '4', count: 40 },
  { name: 'Drinks', id: '5', count: 50 },
];
